import { render, staticRenderFns } from "./GeneralJobDelete.vue?vue&type=template&id=48c09ee6&"
import script from "./GeneralJobDelete.vue?vue&type=script&lang=js&"
export * from "./GeneralJobDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports